export enum enumFilerCodeState {
  ERROR,
  SENT,
  SUCCESS,
}
